import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home__headline-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "headline-side-container" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "home__headline" }, "Game Selection", -1)
const _hoisted_5 = { class: "headline-side-container" }
const _hoisted_6 = { class: "home__game-container" }
const _hoisted_7 = { class: "home__games" }
const _hoisted_8 = {
  key: 0,
  class: "home__game-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_game_card = _resolveComponent("game-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_icon_button, {
          icon: "color-switch",
          "hover-action": "rotate-in",
          class: "m1-right",
          onClick: _ctx.switchTheme
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
          return (_openBlock(), _createBlock(_component_game_card, _mergeProps({
            key: game.name
          }, game), null, 16))
        }), 128)),
        (_ctx.games.length % 3 === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}